import script from "./AlertModalContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlertModalContent.vue?vue&type=script&setup=true&lang=ts"

import "./AlertModalContent.vue?vue&type=style&index=0&id=10b91e6c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10b91e6c"]])

export default __exports__